<template>
  <BaseAction>
    <PrimaryButton :loading="submitting" @click.native="openDialog" shrink>
      Submit for Approval
    </PrimaryButton>
    <ConfirmationDialog
      title="Are you sure you want to submit the reference for approval?"
      subText="This will automatically send an email to request a reference from the
        referee for review"
      buttonText="Submit for Approval"
      :isOpen="isOpen"
      :isLoading="submitting"
      @close="closeDialog"
      @submit="submit"
    />
  </BaseAction>
</template>

<script>
import PrimaryButton from "@/components/common/Button/PrimaryButton";
import BaseAction from "@/components/common/BaseAction";
import { SUBMIT_REFERENCE_FOR_APPROVAL } from "@/store/modules/references/actions";
import { REFERENCES_NAMESPACE } from "@/store/modules/references";
import { createNamespacedHelpers } from "vuex";
import ConfirmationDialog from "@/components/common/ConfirmationDialog";

const { mapActions } = createNamespacedHelpers(REFERENCES_NAMESPACE);

export default {
  props: {
    referenceId: String
  },
  components: {
    BaseAction,
    PrimaryButton,
    ConfirmationDialog
  },
  data() {
    return {
      submitting: false,
      isOpen: false
    };
  },
  methods: {
    ...mapActions({
      submitForApproval: SUBMIT_REFERENCE_FOR_APPROVAL
    }),
    async submit() {
      this.submitting = true;
      await this.submitForApproval(this.referenceId);
      this.submitting = false;
      this.closeDialog();
    },
    openDialog() {
      this.isOpen = true;
    },
    closeDialog() {
      this.isOpen = false;
    }
  }
};
</script>
